export const SHIP_SIZES = [1, 2, 3, 4];
/** Klasyczny polski skład: 4 jednomasztowce, 3 dwumasztowce, 2 trójmasztowce, 1 czteromasztowiec. */
export const CLASSIC_ROSTER = { 1: 4, 2: 3, 3: 2, 4: 1 };
/**
 * Domyślne zasady: klasyka polska, bez limitów czasu.
 *
 * Zegary są świadomie wyłączone. Rdzeń i protokół potrafią je obsłużyć, więc włączenie
 * ich później w ustawieniach partii jest zmianą konfiguracji, a nie zmianą kodu — patrz
 * `withTimeouts`. Konsekwencja braku limitu: przeciwnik może zwlekać z ruchem dowolnie
 * długo, a partię odblokowuje dopiero rozłączenie (mechanizm porzucenia) albo poddanie się.
 */
export const CLASSIC_RULESET = {
    boardSize: 10,
    roster: CLASSIC_ROSTER,
    extraShotOnHit: true,
    autoRevealHaloOnSunk: true,
    turnTimeoutSec: null,
    placementTimeoutSec: null,
};
/** Wartości proponowane, gdy gracz włączy limity czasu w ustawieniach partii. */
export const SUGGESTED_TIMEOUTS = { turnSec: 60, placementSec: 180 };
/**
 * Włącza limity czasu w zestawie zasad. `null` w polu zostawia dany limit wyłączony.
 * To jedyna droga do uzbrojenia zegarów — dzięki temu "bez limitu" jest stanem domyślnym,
 * a nie czymś, o czym trzeba pamiętać.
 */
export function withTimeouts(ruleset, timeouts = {}) {
    return {
        ...ruleset,
        turnTimeoutSec: timeouts.turnSec === undefined ? SUGGESTED_TIMEOUTS.turnSec : timeouts.turnSec,
        placementTimeoutSec: timeouts.placementSec === undefined ? SUGGESTED_TIMEOUTS.placementSec : timeouts.placementSec,
    };
}
/** Ile statków liczy flota o danym składzie. */
export function shipCount(roster) {
    return SHIP_SIZES.reduce((sum, size) => sum + roster[size], 0);
}
/** Ile pól zajmuje pełna flota — tyle trafień potrzeba do zwycięstwa. */
export function totalShipCells(roster) {
    return SHIP_SIZES.reduce((sum, size) => sum + roster[size] * size, 0);
}
/** Etykieta pola w notacji planszowej, np. `{ x: 3, y: 6 }` → `"D7"`. */
export function coordLabel(x, y) {
    return `${String.fromCharCode(65 + x)}${y + 1}`;
}
//# sourceMappingURL=ruleset.js.map